import {
  defaultSimpleAcceptCollection,
  exists,
  SimpleAcceptCollection,
  SimpleAcceptCollectionFromJSON
} from '@/api'

export interface SimpleAcceptOrderResponse {
  collection: SimpleAcceptCollection
  receiptInfoReserve: any
  receiptInfoReserveForwarding: any
}

export function SimpleAcceptOrderResponseFromJSON(
  json: any
): SimpleAcceptOrderResponse {
  return {
    collection: exists(json, 'collection')
      ? SimpleAcceptCollectionFromJSON(json.collection)
      : defaultSimpleAcceptCollection(),
    receiptInfoReserve: exists(json, 'receipt_info_reserve')
      ? json.receipt_info_reserve
      : undefined,
    receiptInfoReserveForwarding: exists(
      json,
      'receipt_info_reserve_forwarding'
    )
      ? json.receipt_info_reserve_forwarding
      : undefined
  }
}
